const TableTopTitle = (props) => {
  return (
    <div className="flex-row mb-2">
      <div className="text-lg font-medium mb-2">{props.title}</div>
      <div className="text-400">{props.subTitle}</div>
    </div>
  );
};

export default TableTopTitle;